import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import { H4 } from "../../../../AbstractElements";

import { Button, Select } from "antd";
import axios from "axios";
import { toast } from "react-toastify";
import { fetchUserDetails } from "../../../../api/user.api";
import { EmailAddress, Name, Save } from "../../../../Constant";
import { LogEvents, LoggerContext } from "../../../../context/logging";
import { useAPIUser } from "../../../../_helper/User/UserProvider";

const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const EditMyProfile = (props) => {
  const { dispatch } = props;
  const logger = React.useContext(LoggerContext);

  const [details, setDetails] = useState({});
  const { userDetails, setUserDetails } = useAPIUser();

  const [nameError, setNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [designationError, setDesignationError] = useState(false);
  const [departmentError, setDepartmentError] = useState(false);

  useEffect(() => {
    getUserDetails();
  }, [userDetails]);

  const getUserDetails = () => {
    fetchUserDetails().then((res) => {
      setDetails(res);
      localStorage.setItem("currentUser", JSON.stringify(res));
      dispatch({
        type: "settings/CHANGE_SETTING",
        payload: {
          setting: "user",
          value: res,
        },
      });
    });
  };
  const editProfile = (e) => {
    setNameError(false);
    setEmailError(false);
    setDesignationError(false);
    setDepartmentError(false);

    const nameFieldTest = /^[A-Za-z]+[A-Za-z ]*$/;
    if (nameFieldTest.test(details.name)) {
      setNameError(false);
    } else {
      setNameError(true);
    }

    const emailFieldTest = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailFieldTest.test(details.email)) {
      setEmailError(false);
    } else {
      setEmailError(true);
    }

    function departmentCheckFunction() {
      return true;
    }
    if (details.department) {
      const departmentFieldTest = /^[A-Za-z]+[A-Za-z ]*$/;
      departmentCheckFunction = () => {
        if (departmentFieldTest.test(details.department)) {
          setDepartmentError(false);
          return true;
        } else {
          setDepartmentError(true);
          return false;
        }
      };
    }

    function designationCheckFunction() {
      return true;
    }
    if (details.designation) {
      const designationTest = /^[A-Za-z]+[A-Za-z ]*$/;
      designationCheckFunction = () => {
        if (designationTest.test(details.designation)) {
          setDesignationError(false);
          return true;
        } else {
          setDesignationError(true);
          return false;
        }
      };
    }

    if (
      nameFieldTest.test(details.name) &&
      emailFieldTest.test(details.email) &&
      departmentCheckFunction() &&
      designationCheckFunction()
    ) {
      const values = new FormData();
      values.append("name", details.name);
      values.append("email", details.email);
      values.append("contact", details.contact);
      values.append("email_preference", details?.email_preference);

      values.append("designation", details.designation);

      values.append("department", details.department);
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      axios
        .put(`apiV1/user/${details.id}/`, values, config)
        .then((res) => {
          setDetails(res.data);
          setUserDetails(res.data);
          toast.success("Successfully edited details");
        })
        .catch((error) => {
          toast.error("Could not edit your profile details. Please try again");
        });
    } else {
      toast.error("Enter details correctly");
    }
  };

  const handleChangeEmailPreference = (value) => {
    setDetails({
      ...details,
      email_preference: value,
    });
  };
  return (
    <Fragment>
      <Card>
        <CardHeader className="pb-0">
          <H4 attrH4={{ className: "card-title mb-0" }}>Edit my profile</H4>
          <div className="card-options">
            <a className="card-options-collapse" href="#javascript">
              <i className="fe fe-chevron-up"></i>
            </a>
            <a className="card-options-remove" href="#javascript">
              <i className="fe fe-x"></i>
            </a>
          </div>
        </CardHeader>
        <CardBody>
          <Form>
            <FormGroup className="mb-3">
              <Label className="form-label">{Name}</Label>
              <Input
                className="form-control"
                placeholder="Name"
                defaultValue={details?.name}
                onChange={(e) => {
                  setDetails({
                    ...details,
                    name: e.target.value,
                  });
                }}
              />
              {nameError ? (
                <span style={{ color: "red" }}>Enter a valid name</span>
              ) : null}
            </FormGroup>
            <FormGroup className="mb-3">
              <Label className="form-label">{EmailAddress}</Label>
              <Input
                className="form-control"
                placeholder="Email"
                defaultValue={details?.email}
                onChange={(e) => {
                  setDetails({
                    ...details,
                    email: e.target.value,
                  });
                }}
              />
              {emailError ? (
                <span style={{ color: "red" }}>Enter a valid Email</span>
              ) : null}
            </FormGroup>
            <FormGroup className="mb-3">
              <Label className="form-label">{"Designation"}</Label>
              <Input
                className="form-control"
                defaultValue={details?.designation}
                onChange={(e) => {
                  setDetails({
                    ...details,
                    designation: e.target.value,
                  });
                }}
              />
              {designationError ? (
                <span style={{ color: "red" }}>Enter a valid Designation</span>
              ) : null}
            </FormGroup>
            <FormGroup className="mb-3">
              <Label className="form-label">{"Department"}</Label>
              <Input
                className="form-control"
                defaultValue={details?.department}
                onChange={(e) => {
                  setDetails({
                    ...details,
                    department: e.target.value,
                  });
                }}
              />
              {departmentError ? (
                <span style={{ color: "red" }}>Enter a valid Department</span>
              ) : null}
            </FormGroup>

            <FormGroup className="mb-3">
              <Label className="form-label">Email Preference</Label>
              <br />
              <Select
                value={details?.email_preference}
                style={{
                  width: 180,
                }}
                onChange={handleChangeEmailPreference}
                options={[
                  {
                    value: "all",
                    label: "All",
                  },
                  {
                    value: "priority",
                    label: "Priority",
                  },
                  {
                    value: "none",
                    label: "None",
                  },
                ]}
              />
            </FormGroup>

            <div className="form-footer">
              <Button
                className="btn-block"
                onClick={(e) => {
                  editProfile(e);
                }}
              >
                {Save}
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default connect(mapStateToProps)(EditMyProfile);
